import React from 'react';

export interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'accent' | 'outline';
  children: React.ReactNode;
  pulse?: boolean;
}

export function Badge({ variant = 'default', children, pulse = false }: BadgeProps) {
  const variants = {
    default: 'bg-gray-800 text-gray-300 border-gray-700',
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
    danger: 'bg-rose-500/10 text-rose-400 border-rose-500/30',
    accent: 'bg-violet-500/10 text-violet-400 border-violet-500/30',
    outline: 'bg-transparent text-gray-400 border-gray-700',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]}`}
    >
      {pulse && (
        <span className="relative flex h-2 w-2">
          <span
            className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
              variant === 'success' ? 'bg-emerald-400' : 'bg-violet-400'
            }`}
          />
          <span
            className={`relative inline-flex rounded-full h-2 w-2 ${
              variant === 'success' ? 'bg-emerald-500' : 'bg-violet-500'
            }`}
          />
        </span>
      )}
      {children}
    </span>
  );
}

